import { render, staticRenderFns } from "./introText.vue?vue&type=template&id=ffb7b556&"
import script from "./introText.vue?vue&type=script&lang=js&"
export * from "./introText.vue?vue&type=script&lang=js&"
import style0 from "./introText.vue?vue&type=style&index=0&id=ffb7b556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports